/**
 * Trade & Media Page
 */

export default function HWY_Trade_Media() {
	const selectors = {
		wine: ".page-trade-media .wine",
		name: ".page-trade-media .wine-name",
	};

	this.init = () => {

		handleCaret();

	};

	const handleCaret = () => {
		jQuery(selectors.name).on("click", function() {
			jQuery(this).find(".caret").toggleClass("rotate");
			if(jQuery(this).find(".caret").hasClass("rotate")) {
				jQuery(this).next().slideDown(300)
			} else {
				jQuery(this).next().slideUp(300)
			}
		})
	}
}
